import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ActivityHistoryDrawerState {
  isOpen: boolean;
}

const initialState: ActivityHistoryDrawerState = {
  isOpen: false,
};

const activityHistoryDrawerSlice = createSlice({
  name: "activityHistoryDrawer",
  initialState,
  reducers: {
    openActivityHistoryDrawer: (state) => {
      state.isOpen = true;
    },
    closeActivityHistoryDrawer: (state) => {
      state.isOpen = false;
    },
    setActivityHistoryDrawerOpen: (state, action: PayloadAction<boolean>) => {
      state.isOpen = action.payload;
    },
  },
});

export const {
  openActivityHistoryDrawer,
  closeActivityHistoryDrawer,
  setActivityHistoryDrawerOpen,
} = activityHistoryDrawerSlice.actions;

export default activityHistoryDrawerSlice.reducer;
